<style lang="stylus">
    .note-dialog{
        width: 640px;
        .dialog-slot{
          padding-top: 10px
        }
        .edit-tool{
            margin-bottom: 16px
            display: flex;
            align-items: center;
            .note-reun{
                margin-right: 2px;
                display: flex;
                column-gap 8px
                .disabled{
                    opacity: 0.2 !important;
                    pointer-events: none;
                    cursor: no-drop !important;
                }
                >div{
                    width: 24px;
                    height: 24px;
                    border-radius: 4px;
                    position: relative;
                    .item-icon{
                        width: 20px;
                        height: 20px;
                        user-select: none;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        color: var(--svg-color-42-secondary)
                    }
                    &:hover{
                        background-color: #eee;
                    }
                    >img{
                        user-select: none;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
            }
            .activeBtn{
                &:hover{
                    background-color: #e5e5e5;
                }
            }
            .down-arrow {
                width: 8px;
            }

        }
        .edit-div{
            padding: 10px
            margin-bottom: 23px;
            height: 278px;
            outline: none;
            border: 1px solid $box-bordercolor;
            overflow-y: auto;
            border-radius: 6px;
        }
        .dialog-enter{
            margin-top: 12px;
            height: 40px;
            position: relative;
            .dialog-op{
                position: absolute;
                width: 78px;
                height: 29px;
                border: 1px solid #e5e5e5;
                border-radius: 3px;
                text-align: center;
                line-height: 28px;
                cursor: default;
                user-select: none;
                &:hover{
                    background-color: #e5e5e5;
                }
            }
            .dialog-ok{
                right: 100px;
            }
            .dialog-cancel{
                right: 15px;
            }
        }
        .dialog-slot{
            @media screen and (max-height: 768px){
               overflow-y: inherit;
            }
        }
        .font-selecter{
          height: 24px
        }
        .font-btn{
          margin-left: 0 !important
          .item-color{
            left: 6px !important;
          }

        }
        .font-name{
          border: 1px solid $box-bordercolor;
          border-radius: 6px;
        }
        .dialog-btnbox-normal{
        }
    }
</style>

<template>
    <Dialog class="note-dialog" :title="$t('title')" :mask="true" :extra="true" @close="checkClose()">
        <div class="edit-tool">
            <div class="note-reun">
                <div :class="{ disabled: !undoStack.length }" @click="undo"><iconSymbol class="item-icon" :name="'note-undo'"></iconSymbol></div>
                <div :class="{ disabled: !redoStack.length }" @click="redo"><iconSymbol class="item-icon" :name="'note-redo'"></iconSymbol></div>
            </div>
            <font ref="font" :from="'note'" @addStack="addNewtoUndoStack" />
        </div>
        <div class="edit-div" ref="editor" id="edNoteEditDiv" contenteditable="true" @keyup.esc="checkClose">
            <p style="padding: 0px; margin: 0px; text-align: left; line-height: 1; font-size: 10pt">
                <span :style="internal ? 'font-size: 10pt' : 'font-size: 12pt'"><br /></span>
            </p>
        </div>
        <!-- <div class='dialog-enter' >
            <div class='dialog-op dialog-ok' @click='setNote'>确定</div>
            <div class='dialog-op dialog-cancel' @click='closeThis'>取消</div>
        </div> -->
        <div class="dialog-btnbox-normal">
            <div class="dialog-btn-ok" @click="setNote()">{{ $t("confirm") }}</div>
            <div class="" @click="checkClose()">{{ $t("cancel") }}</div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    declare var EDTextDocUtil: any;
    declare var EDTextFormat: any;
    declare var TextEditor: any;
    declare var EDView: any;
    // import font from '../Tabs/NavigationFont.vue';
    import font from "../Common/Font.vue";
    import { Component, Watch, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            font,
            Dialog,
        },
    })
    export default class Note extends Vue {
        @Inject()
        ["showMessage"];
        // pointStackIndex:number = 0; //pointer stack index for current status
        undoFlag: boolean = true; //记录初始
        tempRecord: string = ""; //记录undo状态。
        undoStack: Array<string> = [];
        redoStack: Array<string> = [];

        checkClose() {
            let oldHTML;
            if (this.activeFloatItem != -1) {
                oldHTML = this.floatMenuList[this.activeFloatItem]?.noteText;
            } else if (this.activeShapeID != 0) {
                for (let i = 0; i < this.floatMenuList.length; ++i) {
                    if (this.floatMenuList[i].id == this.activeShapeID) {
                        oldHTML = this.floatMenuList[i].noteText;
                        break;
                    }
                }
            }
            let html = (<HTMLElement>this.$refs.editor).innerHTML;
            let nullTextContent = !(<HTMLElement>this.$refs.editor).textContent.trim();

            if (!nullTextContent && html != oldHTML) {
                let msg = this.$t("noteUnsave");
                this.showMessage({
                    sponsor: "editNote",
                    type: 0,
                    content: msg,
                });
                return;
            }
            this.closeThis();
        }
        closeThis() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
            // 关闭色板
            this.$store.commit("toPalette", { type: null });
            this.$store.commit("setLayoutChild", { idx: -1 });

            this.$store.commit("setStatus", {
                type: "couldFixWindow",
                data: false,
            });
            this.activeFloatItem = -1;
        }
        // get stackLen(){
        //     return this.htmlStack.length;
        // // }
        // get undoIcon(){
        //     if(this.undoStack.length){
        //         return 'note-undo'
        //     }else{
        //         return 'note-undogray'
        //     }
        // }
        // get redoIcon(){
        //     if(this.redoStack.length){
        //         return 'note-redo'
        //     }else{
        //         return 'note-redogray'
        //     }
        // }
        get isEdge() {
            return window.navigator.userAgent.indexOf("Edge") >= 0;
        }
        getDeepTextNode(dom: any) {
            if (dom.childNodes.length == 0) return null;
            let child = dom.childNodes[dom.childNodes.length - 1];
            if (child && child.nodeName != "#text") {
                return this.getDeepTextNode(child);
            } else {
                return child;
            }
        }
        collapse() {
            let editor = <HTMLElement>this.$refs.editor;
            let range = new Range();
            let text = this.getDeepTextNode(editor.lastElementChild);
            if (text) {
                range.selectNodeContents(text);
                range.collapse(); //光标移至最后
                //range.select();
                let select = window.getSelection();
                select.removeAllRanges();
                select.addRange(range);
            }
        }
        redo() {
            if (!this.redoStack.length) return;
            this.undoStack.push((<HTMLElement>this.$refs.editor).innerHTML);
            (<HTMLElement>this.$refs.editor).innerHTML = (<any>this.redoStack).pop();
            this.undoFlag = true;
            this.collapse();
        }
        undo() {
            if (!this.undoStack.length) return;
            this.redoStack.push((<HTMLElement>this.$refs.editor).innerHTML);
            (<HTMLElement>this.$refs.editor).innerHTML = (<any>this.undoStack).pop();
            this.undoFlag = true;
            this.collapse();
        }
        addNewtoUndoStack(html?: string) {
            this.redoStack = [];
            if (html) {
                this.undoStack.push(html);
                this.undoFlag = true;
            } else {
                if ((<HTMLElement>this.$refs.editor).innerHTML === this.undoStack[this.undoStack.length - 1]) {
                    return;
                }
                this.undoStack.push((<HTMLElement>this.$refs.editor).innerHTML);
                this.undoFlag = true;
            }
        }

        get noteHTML() {
            return this.$store.state.shape.note;
        }
        setNote() {
            let html = (<HTMLElement>this.$refs.editor).innerHTML;
            let view = window["_view"];
            if (!(<HTMLElement>this.$refs.editor).textContent.trim() && !(<HTMLElement>this.$refs.editor).querySelector("img")) {
                html = "";
            }
            if (!html) {
                this.$edMessage.warning(this.$t("notEmpty"));
                return;
            }
            html = html.replace(/<img/g, "<img style='max-width:100%;'");
            console.log(this.floatMenuList, this.activeFloatItem);
            let id = this.floatMenuList[this.activeFloatItem] ? this.floatMenuList[this.activeFloatItem].id : this.activeShapeID;
            view.editNote(html, id);
            this.closeThis();
        }

        get activeFloatItem() {
            return this.$store.state.dialog.activeFloatItem;
        }
        get floatMenuList() {
            return this.$store.state.dialog.floatMenuList;
        }
        get activeShapeID() {
            return this.$store.state.shape.id;
        }
        set activeFloatItem(v) {
            this.$store.commit("setDialogState", {
                type: "activeFloatItem",
                data: v,
            });
        }
        insertImgToNote(event) {
            if (event.clipboardData.getData("text/plain") || event.clipboardData.getData("text/html")) {
                return;
            }
            event.preventDefault();
            const items = event.clipboardData && event.clipboardData.items;
            if (items && items.length) {
                // 检索剪切板items
                for (var i = 0; i < items.length; i++) {
                    if (items[i].type.indexOf("image") !== -1) {
                        const file = items[i].getAsFile();
                        let view = window["_view"];
                        let blob = new Blob([file], { type: file.type });
                        view.insertImgtoNote(blob);
                    }
                }
            }
        }
        getFontStyle() {
            let ts: any = this;
            let style = {};
            if (this.$store.state.dialog.showDialog && this.$store.state.dialog.dialogType === "note") {
                let font = ts.$refs.font;
                style = {
                    family: font.activedFamily,
                    size: font.activedSize,
                    bold: font.bold,
                    italic: font.italic,
                    underline: font.underline,
                    strike: font.strike,
                    fontColor: font.fontColor,
                    backColor: font.backColor,
                };
            }
            return style;
        }
        //生命周期
        mounted() {
            let ts = this as any;
            let editor = <HTMLElement>this.$refs.editor;
            editor.focus();
            let html;
            console.log(window["_view"]._activeShape);
            if (this.activeFloatItem != -1) {
                html = this.floatMenuList[this.activeFloatItem].noteText;
            } else if (this.activeShapeID != 0) {
                for (let i = 0; i < this.floatMenuList.length; ++i) {
                    if (this.floatMenuList[i].id == this.activeShapeID) {
                        html = this.floatMenuList[i].noteText;
                        break;
                    }
                }
            }
            if (html) {
                editor.innerHTML = html;
                setTimeout(this.collapse, 0);
                // this.collapse();
            }
            editor.addEventListener("paste", (e) => {
                e.stopPropagation();
                e.preventDefault();
                let text = e.clipboardData.getData("text/plain") || "";
                document.execCommand("insertText", false, text);
                this.insertImgToNote(e);
                this.addNewtoUndoStack();
            });
            editor.addEventListener("cut", (e) => {
                e.stopPropagation();
                this.addNewtoUndoStack();
            });
            editor.addEventListener("keydown", (e) => {
                e.stopPropagation();
                let ctrlKey = EDView.osInfo.platform === "Mac" ? e.metaKey : e.ctrlKey;
                if (ctrlKey) {
                    let view: any = window["_view"];
                    if (e.keyCode === 90 || e.keyCode === 89) {
                        e.preventDefault();
                        if (e.keyCode === 90) {
                            this.undo();
                        } else {
                            this.redo();
                        }
                    } else if (e.keyCode === 66) {
                        // bold

                        event.preventDefault();
                        ts.addNewtoUndoStack();
                        view.editStyle("bold", !ts.$refs.font.bold);
                        ts.$refs.font.bold = !ts.$refs.font.bold;
                    } else if (e.keyCode === 73) {
                        event.preventDefault();
                        ts.addNewtoUndoStack();
                        view.editStyle("italy", !ts.$refs.font.italic);
                        ts.$refs.font.italic = !ts.$refs.font.italic;
                    } else if (e.keyCode === 85) {
                        event.preventDefault();
                        ts.addNewtoUndoStack();
                        view.editStyle("underline", !ts.$refs.font.underline);
                        ts.$refs.font.underline = !ts.$refs.font.underline;
                    } else if (e.keyCode === 83) {
                        event.preventDefault();
                    }
                } else {
                    if (e.key.length === 1 && this.undoFlag) {
                        this.addNewtoUndoStack();
                        this.undoFlag = false;
                    }
                }
            });
            editor.addEventListener("compositionstart", (e) => {
                this.tempRecord = (<HTMLElement>this.$refs.editor).innerHTML;
            });
            editor.addEventListener("compositionupdate", (e) => {});
            editor.addEventListener("compositionend", (e: CompositionEvent) => {
                if (e.data) {
                    this.addNewtoUndoStack(this.tempRecord);
                }
                this.tempRecord = "";
            });

            let options = {
                characterData: true,
                childList: true,
                subtree: true,
                attributes: true,
            };
            let observer = new MutationObserver(function (mutations, ob) {
                let html = (<HTMLElement>ts.$refs.editor)?.innerHTML;
                if (/(div>)/.test(html)) {
                    html = html.replace(/(div>)/g, "p>");
                    editor.innerHTML = html;
                }
                if (html.match(/^(<br>|)$/)) {
                    let r = document.createRange();
                    r.selectNodeContents(<HTMLElement>ts.$refs.editor);
                    document.getSelection().removeAllRanges();
                    document.getSelection().addRange(r);

                    if (ts.isEdge) {
                        document.execCommand("insertHTML", false, "<p></p>");
                    } else {
                        document.execCommand("formatBlock", false, "p");
                    }
                } else if (html.match(/<p[^>]*><\/p>/)) {
                }
                if (!editor.getElementsByTagName("span").length && !editor.getElementsByTagName("img").length) {
                    let defaultFormat = new EDTextFormat();
                    let { family, size, bold, italic, underline, strike, fontColor, backColor } = ts.getFontStyle();
                    defaultFormat._blockFmt._align = "left";
                    defaultFormat._charFmt._font = family;
                    defaultFormat._charFmt._size = size;
                    defaultFormat._charFmt._color = fontColor;
                    defaultFormat._charFmt._bkColor = backColor;
                    defaultFormat._charFmt.bold(bold);
                    defaultFormat._charFmt.italic(italic);
                    defaultFormat._charFmt.underline(underline);
                    defaultFormat._charFmt.strikeout(strike);
                    let newHtml = EDTextDocUtil.createHTMLFormTextFormat(defaultFormat);
                    editor.innerHTML = newHtml;
                    // EDTextDocUtil.formatEditorHTML(newHtml, editor, false, true, true);
                }
                // let remainDiv = _this._contentDiv.getElementsByTagName('div');      //删除浏览器添加的多余Div
                // if (remainDiv.length) {
                //     document.execCommand('formatBlock', false, '<p>')
                // }
            });
            observer.observe(editor, options);
            ts.$bus.$on("modNoteColor", this.addNewtoUndoStack);
            ts.$bus.$on("msgOperation", (data) => {
                if (data.sponsor == "editNote") {
                    if (data.data) this.setNote();
                    else this.closeThis();
                }
            });
        }

        beforeDestroy() {
            let ts = this as any;
            ts.$bus.$off("modNoteColor");
            ts.$bus.$off("msgOperation");
        }
        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "confirm": "保存",
    "cancel": "取消",
    "title": "插入注释",
    "noteUnsave": "注释已更改，是否保存更改？",
    "notEmpty": "注释不能为空！"
  },
  "en": {
    "confirm": "Save",
    "cancel": "Cancel",
    "title": "Insert Note",
    "noteUnsave": "The comment has changed. Do you want to save the changes?"
  },
  "jp": {
    "confirm": "保存",
    "cancel": "キャンセル",
    "title": "注釈を挿入",
    "noteUnsave": "注釈が変更されました。変更を保存しますか？"
  },
  "fr": {
    "confirm": "Enregistrer",
    "cancel": "Annuler",
    "title": "Insérer Note",
    "noteUnsave": "Le commentaire a changé. Voulez-vous enregistrer vos modifications?"
  },
  "de": {
    "confirm": "Speichern",
    "cancel": "Stornieren",
    "title": "Hinweis einfügen",
    "noteUnsave": "Der Kommentar hat sich geändert. Möchten Sie die Änderungen speichern?"
  },
  "es": {
    "confirm": "Guardar",
    "cancel": "Cancelar",
    "title": "Insertar nota",
    "noteUnsave": "El comentario ha cambiado. ¿Quieres guardar los cambios?"
  },
  "pt": {
    "confirm": "Gravar",
    "cancel": "Cancelar",
    "title": "Inserir Nota",
    "noteUnsave": "O comentário foi alterado. Deseja gravar as alterações?"
  },
  "it": {
    "confirm": "Salva",
    "cancel": "Annulla",
    "title": "Inserisci Nota",
    "noteUnsave": "Il commento è stato modificato. Desideri salvare le modifiche?"
  },
  "tw": {
    "confirm": "儲存",
    "cancel": "取消",
    "title": "插入注釋",
    "noteUnsave": "注釋已更改，是否儲存更改？"
  },
  "kr": {
    "confirm": "저장",
    "cancel": "취소",
    "title": "주석 삽입",
    "noteUnsave": "주석이 변경되었습니다. 변경 사항을 저장하시겠습니까?",
    "notEmpty": "주석이 비어 있으면 안 됩니다!"
  }
}
</i18n>
